import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-attr-shape-03",
  "use": "icon-attr-shape-03-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-attr-shape-03\"><path d=\"m27.737 14.17-5.477 4.87 1.43 7.035c.046.23-.019.468-.176.648s-.39.281-.635.277a.85.85 0 0 1-.404-.097l-6.477-3.499-6.542 3.48a.84.84 0 0 1-.867-.053.76.76 0 0 1-.32-.776l1.45-7.031-5.461-4.886a.76.76 0 0 1-.218-.81.8.8 0 0 1 .675-.53l7.413-.852 3.145-6.499A.81.81 0 0 1 15.998 5c.314 0 .6.177.732.45l3.146 6.508 7.412.866a.8.8 0 0 1 .673.535.75.75 0 0 1-.224.81z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol